export const projects = [
  {
    id: "1",
    name: "FIFA Products",
    madeAt: "Netcompany",
    techs: [
      "C#",
      "Python",
      "Elasticsearch",
      ".NET Core",
      "Azure Function",
      "CI/CD Azure",
      "Contentful",
    ],
    contributions: [
      "Backend and Data Indexing services",
      "Search functionalities",
      "Video Work Flow",
      "Contentful App Webhook",
      ". . .",
    ],
    urls: [
      { name: "FIFA.com", url: "https://www.fifa.com/en" },
      { name: "Inside.FIFA.com", url: "https://inside.fifa.com/" },
      { name: "Media.FIFA.com", url: "https://media.fifa.com/" },
    ],
  },
  {
    id: "2",
    name: "NFT Marketplace",
    madeAt: "CS300 - Software Engineering",
    techs: ["Node.js", "TypeScript", "Next.js", "MongoDB", "Solidity", "Etherium Testnet"],
    contributions: [
      "Backend and Data Indexing services",
      "Search functionalities",
      "Video Work Flow",
      "Contentful App Webhook",
      ". . .",
    ],
    urls: [
      {
        name: "Github",
        url: "https://github.com/lnqminh3003/AuraSky-NFT-Marketplace",
      },
      { name: "Link", url: "https://cs-300-aurasky-marketplace.vercel.app/" },
    ],
  },
];
